import { Link } from 'react-router-dom';

interface GameCardProps {
  id: number;
  title: string;
  image: string;
  category: string;
  description: string;
  rating: number;
  downloads: number;
  size: string;
  platform: string;
  tags: string[];
  isHot?: boolean;
  isNew?: boolean;
}

const categoryNames: Record<string, string> = {
  hanhua: '汉化版',
  riwen: '日文原版',
  buding: '补丁包',
  gonglve: '攻略合集',
  quanlingyu: '全年龄',
  remake: '重制版',
  tongren: '同人佳作',
  xinyou: '新作速递',
};

export default function GameCard({
  id,
  title,
  image,
  category,
  description,
  rating,
  downloads,
  size,
  platform,
  tags,
  isHot,
  isNew,
}: GameCardProps) {
  const downloadText = downloads >= 10000 ? `${(downloads / 10000).toFixed(1)}万` : downloads.toString();

  return (
    <article className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden transition-all duration-300 hover:border-primary-300/60" data-product-shop>
      <Link to={`/article/${id}`} className="block cursor-pointer">
        <div className="relative aspect-[4/3] overflow-hidden bg-background-200/50">
          <img
            src={image}
            alt={title}
            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <div className="absolute top-2 left-2 flex gap-1.5">
            {isHot && (
              <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-accent-500 text-background-50">
                热门
              </span>
            )}
            {isNew && (
              <span className="px-2 py-0.5 rounded-md text-xs font-medium bg-primary-500 text-background-50">
                新作
              </span>
            )}
          </div>
          <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-3">
            <span className="text-xs text-white/80">{categoryNames[category] || category}</span>
          </div>
        </div>
      </Link>

      <div className="p-4">
        <Link to={`/article/${id}`} className="block cursor-pointer">
          <h3 className="font-heading text-base font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors mb-1.5">
            {title}
          </h3>
        </Link>
        <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed mb-3">
          {description}
        </p>

        <div className="flex items-center gap-4 text-xs text-foreground-400 mb-3">
          <span className="flex items-center gap-1">
            <i className="ri-star-fill text-accent-500 text-sm"></i>
            {rating}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-download-line"></i>
            {downloadText}
          </span>
          <span>{size}</span>
        </div>

        <div className="flex flex-wrap gap-1.5 mb-3">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 rounded-md text-xs bg-secondary-100 text-secondary-700"
            >
              {tag}
            </span>
          ))}
        </div>

        <div className="flex items-center justify-between pt-3 border-t border-background-200/70">
          <span className="text-xs text-foreground-400">{platform}</span>
          <Link
            to={`/article/${id}`}
            className="text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors flex items-center gap-1 cursor-pointer whitespace-nowrap"
          >
            查看详情
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </article>
  );
}